var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{staticStyle:{"background":"linear-gradient(180deg, #66b5e5 0%, #635ddb 100%)"}},[_c('v-main',[_c('FormLogin')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }